import { useState } from 'react'
import { price } from '../data/price'
import { priceCategories } from '../data/priceCategories'
import './styles/Price.scss'

function formatPrice(value) {
    const number = Number(value.toString().replace(/\s/g, ''))
    return number.toLocaleString('ru-RU') + ' ₸'
}

function Price() {
    const [activeCategoryId, setActiveCategoryId] = useState(null)

    const handleToggle = (categoryId) => {
        setActiveCategoryId(prev => (prev === categoryId ? null : categoryId))
    }

    return (
        <div className={'price-container'}>
            {priceCategories.map(category => (
                <div key={category.id} className="category-block">
                    <div
                        className="category-title"
                        onClick={() => handleToggle(category.id)}
                    >
                        {category.title}
                    </div>

                    {activeCategoryId === category.id && (
                        <table className="product-table">
                            <thead>
                            <tr>
                                <th>Название</th>
                                <th>Цена</th>
                            </tr>
                            </thead>
                            <tbody>
                            {price
                                .filter(p => p.category_id === category.id)
                                .map(product => (
                                    <tr key={product.fid}>
                                        <td>{product.title}</td>
                                        <td>{formatPrice(product.price)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            ))}
        </div>
    )
}

export default Price
